// eslint-disable-next-line prettier/prettier
import axios from 'axios'

export const sendServerEvent = async (eventData) => {
  const pixelId = process.env.VUE_APP_META_PIXEL_ID
  const accessToken = process.env.VUE_APP_META_TOKEN

  const url = `https://graph.facebook.com/v21.0/${pixelId}/events`

  const priceInfo = separateCurrencyAndValue(eventData.price)

  const payload = {
    data: [
      {
        event_name: eventData.eventName, // e.g., 'Purchase'
        event_time: Math.floor(Date.now() / 1000), // Unix timestamp
        user_data: {
          em: [await hashEmail(eventData.email)], // Hashed email address
        },
        custom_data: {
          value: priceInfo.value,
          currency: priceInfo.currency,
        },
        event_id: eventData.eventId, // Unique ID for deduplication
        action_source: 'website',
      },
    ],
  }



  try {
    await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
  } catch (error) {
    console.error('Error sending event:', error)
  }
}

const hashEmail = async (email) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

const separateCurrencyAndValue = (price) => {
  const regex = /^([a-zA-Z]+)\s(\d+(\.\d+)?)/
  const match = price.match(regex)

  if(!match) {
    return null
  }

  return {
    currency: match[1],
    value: parseFloat(match[2]),
  }
}
